class JSQlikLoader {
    constructor() {
        if (JSQlikLoader.instance) {
            return JSQlikLoader.instance;
        }
        JSQlikLoader.instance = this;
        this.connection = null;
        return JSQlikLoader.instance;
    }

    async init() {
        if (!this.connection) {
            this.connection = await this._getQlik();
        }
        return this.connection;
    }

    async _getQlik() {
        return new Promise((resolve, reject) => {
            window.require(['js/qlik'], (qlik) => {
                if (qlik) {
                    resolve(qlik);
                } else {
                    console.error('js/qlik failed to load');
                    reject(null);
                }
            });
        });
    }
}
export default JSQlikLoader;
